import { useMemo } from 'react';
import { ImportFormatItem } from '../../../../lib/imports/importTypes';
import {
  EntityListProductInputData,
  EntityListTypeSupported,
  getEntityListSpecification,
} from '../entityListsLib';

/**
 * Returns a list of keys that form the format of importContent. The content may change based on user's choice of instruction.
 */
const useEntityListImportFormat = <T extends EntityListProductInputData>(
  entityListType: EntityListTypeSupported,
): readonly ImportFormatItem<T>[] => {
  const specification = getEntityListSpecification(entityListType);

  return useMemo((): readonly ImportFormatItem<T>[] => {
    return specification.getInputFormat();
  }, [specification]);
};

export default useEntityListImportFormat;
